var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAirElement1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6730_1207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 0C5.86208 0 4.88402 0.710938 4.49279 1.71635C4.38762 1.89934 4.40024 2.12861 4.52434 2.29898C4.64844 2.46935 4.86088 2.55349 5.06701 2.51142C5.27524 2.46935 5.4393 2.3095 5.48558 2.10337C5.71905 1.5018 6.3101 1.07692 7 1.07692C7.89814 1.07692 8.61539 1.79417 8.61539 2.69231C8.61539 3.59045 7.89814 4.30769 7 4.30769H0V5.38462H7C8.48077 5.38462 9.69231 4.17308 9.69231 2.69231C9.69231 1.21154 8.48077 0 7 0ZM0 6.46154V7.53846H10.7692C11.9639 7.53846 12.9231 8.4976 12.9231 9.69231C12.9231 10.887 11.9682 11.8083 10.7524 11.8462C9.83534 11.8735 9.11809 11.3477 8.78365 10.4327C8.72476 10.2413 8.56701 10.0983 8.3714 10.0604C8.17368 10.0225 7.97386 10.0962 7.84976 10.2518C7.72356 10.4075 7.69411 10.6199 7.77404 10.8029C8.24309 12.0901 9.40835 12.9651 10.7861 12.9231C12.5424 12.8705 14 11.4697 14 9.69231C14 7.91496 12.5466 6.46154 10.7692 6.46154H0ZM0 8.61539V9.69231H3.76923C4.66737 9.69231 5.38462 10.4096 5.38462 11.3077C5.38462 12.2058 4.66737 12.9231 3.76923 12.9231C3.14243 12.9231 2.60817 12.5634 2.33894 12.0481C2.20012 11.7831 1.872 11.6821 1.60697 11.8209C1.34195 11.9597 1.24099 12.2879 1.37981 12.5529C1.82993 13.4111 2.73648 14 3.76923 14C5.25 14 6.46154 12.7885 6.46154 11.3077C6.46154 9.82692 5.25 8.61539 3.76923 8.61539H0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6730_1207"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirElement1);
export default __webpack_public_path__ + "static/media/air-element 1.8e48f4a1f0cde9b5ac3c1865a852273c.svg";
export { ForwardRef as ReactComponent };